import { Config, fetchJSON, noticeError } from '@ratehub/base-ui';

import CreditCardShape from '../definitions/CreditCardShape';
import { PRODUCT_TYPES } from '../definitions/CurrentDocument';
import createCreditCardsAndVerify from './createCreditCardsAndVerify';


const API_ENDPOINT = `${Config.CC_API_URL}/card-queue` ;


/**
 * Fetch credit cards for featured showcase/list according to params
 * @param {object} params - object-based arguments
 * @param {string} params.province - Province code
 * @param {string} params.language - Language code
 * @param {object[]} params.products - An array of requested products ordered by priority
 * @returns {Promise<CreditCardShape[]>} array of credit card objects
 */
async function fetchCreditCardsFeatured(params) {
    // Backend expects a different fallback type value for “all” reward type
    const placements = params.products.map(product => {
        return {
            ...product,
            fallback: {
                type: product.fallback?.type === PRODUCT_TYPES.ANY_REWARDS
                    ? BACKEND_ANY_REWARDS
                    : product.fallback?.type ?? BACKEND_ANY_REWARDS,
            },
        };
    });

    const queryParams = {
        province: params.province,
        language: params.language,
        placements,
    };

    const fetchedQueueResponse = (await fetchJSON({
        url: API_ENDPOINT,
        options: {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify(queryParams),
        },
    },
    'fetchCreditCardsFeatured'));

    const fetchedFeaturedCreditCards = fetchedQueueResponse?.data?.creditCards;

    if (Array.isArray(fetchedFeaturedCreditCards)) {
        fetchedFeaturedCreditCards.forEach((card) => {
            // Credit card always expected to return valid object shape
            // but sometimes if API is called with bad params it can cause unexpected return
            if (!card) {
                noticeError(
                    new Error(`[fetchCreditCardsFeatured] Error unexpected value for ${card}`),
                    {
                        creditCard: card,
                        queryParams: queryParams,
                    },
                );
            } else {
                // Featured credit card sponsored field is dependent on a global field
                // instead of individual cards
                card.sponsored = card.sponsored?.global ?? card.sponsored;
            }
        });

        return createCreditCardsAndVerify(
            fetchedFeaturedCreditCards.filter(apiResponse => !!apiResponse),
            undefined,  // use default userInfo object
            fetchedQueueResponse.data?.valid_approval_likelihood_document
        );
    } else {
        return [];
    }

}

const BACKEND_ANY_REWARDS = 'rewards';


export default fetchCreditCardsFeatured;
